import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { HoverLift } from "./animations/HoverScale";

function ServiceCard({ title, description, icon, href, features = [], image }) {
  // Fallback image if none provided or failed
  const fallbackImage = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='400' height='300'%3E%3Crect fill='%23f3f4f6' width='400' height='300'/%3E%3Ctext fill='%239ca3af' font-family='sans-serif' font-size='18' x='50%25' y='50%25' text-anchor='middle' dy='.3em'%3EService Image%3C/text%3E%3C/svg%3E";

  return (
    <HoverLift y={-6} className="h-full">
      <motion.div 
        className="group bg-white border border-accent-200 rounded-lg overflow-hidden flex flex-col h-full transition-all duration-200 hover:border-primary-400 hover:shadow-md"
        whileHover={{ 
          borderColor: 'rgb(59, 130, 246)',
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)'
        }}
        transition={{ duration: 0.2 }}
      >
      {/* Image container - Corporate style with fixed height */}
      <div className="relative overflow-hidden h-48 bg-accent-100">
        <img
          src={image || fallbackImage}
          alt={title}
          className="w-full h-full object-cover transition-opacity duration-300 group-hover:opacity-90"
          loading="lazy"
          onError={(e) => (e.target.src = fallbackImage)}
        />
        <div className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-accent-900/20"></div>
      </div>

      <div className="p-5 md:p-6 flex flex-col flex-grow min-h-0">
        <h3 className="text-lg md:text-xl font-semibold text-accent-900 mb-2.5 leading-tight">{title}</h3>
        <p className="text-sm text-accent-600 mb-4 flex-grow leading-relaxed min-h-[3rem]">{description}</p>

        {features.length > 0 && (
          <ul className="space-y-2 mb-5 flex-shrink-0 border-t border-accent-100 pt-4">
            {features.slice(0, 4).map((feature, index) => (
              <li key={index} className="flex items-start text-xs md:text-sm text-accent-700">
                <svg
                  className="w-4 h-4 text-primary-600 mr-2.5 flex-shrink-0 mt-0.5"
                  fill="none"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path d="M5 13l4 4L19 7" />
                </svg>
                <span className="line-clamp-2 leading-snug">{feature}</span>
              </li>
            ))}
          </ul>
        )}

        {href && (
          <Link
            to={href}
            className="mt-auto w-full"
          >
            <motion.button
              className="w-full bg-[#15803D] text-white font-medium text-sm md:text-base py-3 px-4 rounded-lg flex items-center justify-center gap-2 transition-all duration-300 ease-in-out focus:outline-none focus:ring-2 focus:ring-[#15803D] focus:ring-offset-2"
              whileHover={{ 
                scale: 1.02,
                backgroundColor: '#0f6b2f'
              }}
              whileTap={{ scale: 0.98 }}
              transition={{ duration: 0.2, ease: "easeInOut" }}
            >
              <span>Learn More</span>
              <motion.svg
                className="w-4 h-4 md:w-5 md:h-5"
                fill="none"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                viewBox="0 0 24 24"
                stroke="currentColor"
                initial={{ x: 0 }}
                whileHover={{ x: 4 }}
                transition={{ duration: 0.2 }}
              >
                <path d="M9 5l7 7-7 7" />
              </motion.svg>
            </motion.button>
          </Link>
        )}
      </div>
      </motion.div>
    </HoverLift>
  );
}

export default ServiceCard;
